export enum NotificationTypes {
  info = 'info',
  success = 'success',
  warn = 'warn',
  error = 'error',
}
